import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, money } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { FileDown, Download, Eye } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function DigitalDownloads() {
  const { addItem } = useCart();
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products", { params: { product_type: "digital" } }).then((r) => setProducts(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
      <div className="max-w-2xl">
        <span className="text-xs tracking-[0.25em] uppercase text-[#8A8175] font-semibold flex items-center gap-2"><FileDown className="h-4 w-4 text-[#8E9A86]" /> Instant downloads</span>
        <h1 className="font-heading text-5xl sm:text-6xl text-[#3A3632] mt-3">Printable planners &amp; journals.</h1>
        <p className="text-lg text-[#6B655F] mt-4 leading-relaxed">Calming, beautifully designed printables — gratitude journals, prayer journals, planners and more. Download, print, and begin.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {products.map((p, i) => (
          <div key={p.id} data-testid={`digital-card-${p.slug}`} className="bg-white rounded-xl border border-[#E5DFD5] overflow-hidden transition-all duration-500 hover:shadow-lg hover:-translate-y-1 gh-fade-up" style={{ animationDelay: `${i * 50}ms` }}>
            <div className="aspect-[4/3] bg-[#F2EFEB] overflow-hidden"><img src={p.image} alt={p.name} className="w-full h-full object-cover" /></div>
            <div className="p-6">
              <h3 className="font-heading text-xl text-[#3A3632]">{p.name}</h3>
              <p className="text-sm text-[#6B655F] mt-1.5 leading-relaxed">{p.short_desc}</p>
              <div className="flex items-center justify-between mt-4">
                <span className="text-[#8E9A86] font-semibold text-lg">{money(p.price)}</span>
                <div className="flex items-center gap-2">
                  <a href={`${BACKEND}/api/journal-preview/${p.slug}`} target="_blank" rel="noreferrer" data-testid={`digital-preview-${p.slug}`}
                    className="border border-[#C4A4A4] text-[#B09090] rounded-full px-4 py-2.5 text-sm font-medium hover:bg-[#C4A4A4]/10 transition-colors inline-flex items-center gap-1.5">
                    <Eye className="h-4 w-4" /> Preview
                  </a>
                  <button onClick={() => { addItem(p, 1); toast.success("Added to cart 💛"); }} data-testid={`digital-add-${p.slug}`}
                    className="bg-[#C4A4A4] text-white rounded-full px-5 py-2.5 text-sm font-medium hover:bg-[#B09090] transition-colors inline-flex items-center gap-1.5">
                    <Download className="h-4 w-4" /> Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
